/* eslint-disable react/jsx-props-no-spreading,max-len */
/* eslint-disable react/destructuring-assignment */
import {
    MutableRefObject,
    useMemo,
} from 'react'
import Divider from '@mui/material/Divider'
import {
    useGridApiRef,
} from '@mui/x-data-grid-pro'

import useDataGridColumns from 'app/PoC/DataGridDemoPages/components/hooks/useDataGridColumns'
import SkyBaseDataGrid, {
    SkyBaseDataGridProps,
    ExtendedGridApiPro,
    ColumnConfigMappingType,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'
import SkyNetDataGridPagination from 'app/PoC/DataGridDemoPages/components/SkyNetDataGridPagination'

import {
    DataGridSupportedFeatures,
} from '../SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'
import {
    featuresToHiddenColumns,
} from '../utils/utils'

import usePersistedVisibleColumns from '../hooks/useVisibiltyModel/usePersistedVisibleColumns'
import useStyles from './SkyNetDataGrid.styles'

type SkyNetDataGridProps = Omit<SkyBaseDataGridProps,
    'visibilityModel' | 'onColumnVisibilityModelChange' | 'columns'> & {
    featuresLists?: DataGridSupportedFeatures[]
    columns: ColumnConfigMappingType[]
}

const emptyArray: DataGridSupportedFeatures[] = []

export default function SkyNetDataGrid(props: Readonly<SkyNetDataGridProps>) {
    const {
        featuresLists = emptyArray,
        height, customDataSource, columns, persistentKey, ...rest
    } = props
    const {
        CustomToolbar, toolbarProps,
    } = props
    const gridApiRef: MutableRefObject<ExtendedGridApiPro> = useGridApiRef()
    const {
        classes,
    } = useStyles({
        height,
    })

    const additionalColumnsForFilters: ColumnConfigMappingType[] = useMemo(() => {
        return featuresToHiddenColumns(featuresLists)
    }, [featuresLists])

    const columnsWithLabels = useDataGridColumns({
        columnsDef: columns,
        customDataSource,
        filtersUnrelatedToColumns: additionalColumnsForFilters,
    })

    const [
        visibilityModel,
        onColumnVisibilityModelChange,
    ] = usePersistedVisibleColumns({
        columns: columnsWithLabels,
        persistentKey,
    })

    const extendedToolbarProps = useMemo(() => {
        if ('CustomToolbar' in props && CustomToolbar) {
            return {
                CustomToolbar,
            }
        }

        if ('toolbarProps' in props) {
            return {
                toolbarProps: {
                    ...toolbarProps,
                    toolbarControls: [
                        ...(toolbarProps?.toolbarControls || []),
                        (toolbarProps?.toolbarControls?.length > 0) ? (
                            <Divider
                                orientation="vertical"
                                variant="middle"
                                sx={{
                                    mx: 1, height: '20px',
                                }}
                            />
                        ) : null,
                    ],
                },
            }
        }

        return {}
    }, [
        CustomToolbar,
        props,
        toolbarProps,
    ])

    return (
        <SkyBaseDataGrid
            persistentKey={persistentKey}
            {...rest}
            {...extendedToolbarProps}
            columns={columnsWithLabels}
            customDataSource={customDataSource}
            gridApiRef={gridApiRef}
            height={height}
            onColumnVisibilityModelChange={onColumnVisibilityModelChange}
            visibilityModel={visibilityModel}
            classNames={{
                container: classes.container,
            }}
            Pagination={SkyNetDataGridPagination}
            enableSortFilterPersistence={false}
        />
    )
}
